/**
 * Do not edit directly, this file was auto-generated.
 */

/**
 * A color value with flexible output methods for use outside of CSS.
 *
 * @example
 *   const c = new Color(1, 106, 113, 1);
 *   c.rgba()       // "rgba(1, 106, 113, 1)"
 *   c.rgba(false)  // { r: 1, g: 106, b: 113, a: 1 }
 *   c.hex()        // "#016a71ff"
 *   c.hex(false)   // "#016a71"
 */
export class Color {
  constructor(r, g, b, a) {
    this.r = r;
    this.g = g;
    this.b = b;
    this.a = a;
  }

  /**
   * Returns the color as an rgba value.
   * @param asString - If true (default), returns an `rgba(r, g, b, a)` string.
   *                   If false, returns an `{ r, g, b, a }` object.
   */
  rgba(asString = true) {
    if (asString) {
      return `rgba(${this.r}, ${this.g}, ${this.b}, ${this.a})`;
    }
    return { r: this.r, g: this.g, b: this.b, a: this.a };
  }

  /**
   * Returns the color as a hex string.
   * @param alpha - If true (default), returns 8-digit hex including the alpha channel.
   *                If false, returns 6-digit hex.
   */
  hex(alpha = true) {
    const r = this.r.toString(16).padStart(2, '0');
    const g = this.g.toString(16).padStart(2, '0');
    const b = this.b.toString(16).padStart(2, '0');
    if (alpha) {
      const a = Math.round(this.a * 255)
        .toString(16)
        .padStart(2, '0');
      return `#${r}${g}${b}${a}`;
    }
    return `#${r}${g}${b}`;
  }

  /** Parse an `rgba(r, g, b, a)` string into a Color instance. */
  static fromRgba(value) {
    const match = value.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*([\d.]+))?\s*\)$/);
    if (!match) throw new Error(`Cannot parse color: ${value}`);
    return new Color(
      Number(match[1]),
      Number(match[2]),
      Number(match[3]),
      match[4] !== undefined ? Number(match[4]) : 1,
    );
  }
}
